var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useState } from "react";
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { usePageOffsetParam } from "./usePageOffsetParam";
import { fetchLibraries } from "../api/libraryService";
import { DEFAULT_PAGE_SIZE } from "../utils/pageSize";
import { usePageSize } from "./usePageSize";
import { isCountCapped } from "../utils/exactCount";
import { useExactTotalCount } from "./useExactTotalCount";
import { DEFAULT_TITLE_SORT } from "../utils/titleSort";
export var useLibrariesData = function (appliedFilters, sort) {
    var _a, _b, _c, _d;
    if (sort === void 0) { sort = DEFAULT_TITLE_SORT; }
    var kyInstance = useOkapiKy();
    var _e = usePageOffsetParam(), pageOffset = _e.pageOffset, setPageOffset = _e.setPageOffset;
    var _f = usePageSize(), pageSize = _f.pageSize, setPageSize = _f.setPageSize;
    var _g = useState(0), setTotalRecords = _g[1];
    var _h = useQuery(["libraries", appliedFilters, sort, pageOffset, pageSize], function () {
        var _a;
        return fetchLibraries(kyInstance, {
            search: ((_a = appliedFilters.name) === null || _a === void 0 ? void 0 : _a.trim()) || undefined,
            type: appliedFilters.types.length
                ? appliedFilters.types
                : undefined,
            sortBy: sort.sortBy,
            sortDir: sort.sortDir,
            offset: pageOffset,
            limit: pageSize,
        });
    }, {
        enabled: true,
        onSuccess: function (responseData) {
            var _a, _b, _c;
            setTotalRecords((_c = (_a = responseData.totalRecords) !== null && _a !== void 0 ? _a : (_b = responseData.items) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0);
        },
    }), data = _h.data, isLoading = _h.isLoading, isFetching = _h.isFetching, isError = _h.isError, error = _h.error, refetch = _h.refetch;
    var totalRecordsExact = data === null || data === void 0 ? void 0 : data.totalRecordsExact;
    var exactTotalRecords = useExactTotalCount({
        queryKey: ["libraries", appliedFilters],
        fetchTotalRecords: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, fetchLibraries(kyInstance, {
                            search: ((_a = appliedFilters.name) === null || _a === void 0 ? void 0 : _a.trim()) || undefined,
                            type: appliedFilters.types.length
                                ? appliedFilters.types
                                : undefined,
                            offset: 0,
                            limit: DEFAULT_PAGE_SIZE,
                            exactCount: true,
                        })];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, response.totalRecords];
                }
            });
        }); },
        totalRecordsExact: totalRecordsExact,
    });
    var changePageSize = useCallback(function (size) {
        setPageSize(size);
        setPageOffset(0);
    }, [setPageSize, setPageOffset]);
    return {
        librariesData: (_a = data === null || data === void 0 ? void 0 : data.items) !== null && _a !== void 0 ? _a : [],
        totalRecords: (_d = (_b = exactTotalRecords !== null && exactTotalRecords !== void 0 ? exactTotalRecords : data === null || data === void 0 ? void 0 : data.totalRecords) !== null && _b !== void 0 ? _b : (_c = data === null || data === void 0 ? void 0 : data.items) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0,
        exactTotalRecords: exactTotalRecords,
        isCountCapped: isCountCapped(totalRecordsExact, exactTotalRecords),
        isLoading: isLoading,
        isFetching: isFetching,
        isError: isError,
        error: error,
        refetch: refetch,
        fetchMoreData: function (offset) { return setPageOffset(offset); },
        pageOffset: pageOffset,
        pageSize: pageSize,
        changePageSize: changePageSize,
    };
};
